import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import OutsideClickHandler from 'react-outside-click-handler'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import domtoimage from 'dom-to-image'
import classnames from 'classnames'
import _ from 'lodash'

import ToggleButton from '../../../ToggleButton'

import DataTable from './components/DataTable'

import { LOCALE_PREFIX } from './constants'
import './style.scss'

@injectIntl
export default class SingleBarGraph extends Component {
    static propTypes = {
        data: PropTypes.array,
        dataType: PropTypes.oneOf(['assets', 'liabilities']).isRequired,
        handleChangeGraphYear: PropTypes.func.isRequired,
        handleChangeTableActive: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        showDataTable: PropTypes.bool,
        year: PropTypes.number,
    }

    static defaultProps = {
        showDataTable: false,
    }

    constructor(props) {
        super(props)

        this.singleBarGraphRef = React.createRef()

        this.state = {
            dropdownActive: false,
        }
    }

    onToggleDataTableActive = (active) => {
        const { dataType, handleChangeTableActive } = this.props

        handleChangeTableActive(dataType, active)
    }

    onDropdownRowClick = (year) => {
        const { dataType, handleChangeGraphYear } = this.props

        handleChangeGraphYear(dataType, year)
        this.handleCloseDropdown()
    }

    handleToggleDropdown = () => {
        const { dropdownActive } = this.state

        this.setState({ dropdownActive: !dropdownActive })
    }

    handleCloseDropdown = () => {
        this.setState({ dropdownActive: false })
    }

    handleExportAsImageClick = () => {
        const graphNode = this.singleBarGraphRef.current

        domtoimage.toBlob(graphNode).then((blob) => {
            window.saveAs(blob, 'my-node.png')
        })
    }

    render() {
        const { data, dataType, intl, year, showDataTable } = this.props
        const { dropdownActive } = this.state

        if (_.isEmpty(data)) return null

        const yearObj = _.find(data, { year })
        const showBarGraph = _(yearObj)
            .get('rows', [])
            .every((x) => {
                if (_.isNull(_.get(x, 'amount'))) return true

                return _.get(x, 'amount.amount') >= 0
            })

        return (
            <div className={'single-bar-graph'} ref={this.singleBarGraphRef}>
                <div className={'graph-header'}>
                    <span className={'title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                    </span>
                    <div className={'toggle'}>
                        <ToggleButton
                            active={showDataTable || false}
                            textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                            textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                            inactiveGreyBackground
                            inactiveGreyBorder
                            onClickHandler={(active) => this.onToggleDataTableActive(active)}
                        />
                    </div>
                    {/* <button className={'export-as-image-btn'} onClick={() => this.handleExportAsImageClick()}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.exportAsImage`} />
                    </button> */}
                </div>
                <div className={'bar-container'}>
                    <div className={'value-container'}>
                        <span className={'value'}>{year || ''}</span>
                        <OutsideClickHandler
                            disabled={!dropdownActive}
                            onOutsideClick={() => this.handleCloseDropdown()}
                        >
                            <button className={'dropdown-btn'} onClick={() => this.handleToggleDropdown()} />
                            <div className={classnames('dropdown-menu', dropdownActive && 'active')}>
                                {_.map(data, (row, index) => (
                                    <div
                                        key={`${dataType}-dropdown-${index}-row`}
                                        className={'dropdown-row'}
                                        onClick={() => this.onDropdownRowClick(_.get(row, 'year', null))}
                                    >
                                        <span className={'dropdown-text'}>{_.get(row, 'year', null)}</span>
                                    </div>
                                ))}
                            </div>
                        </OutsideClickHandler>
                    </div>
                    {showBarGraph && (
                        <div className={'graph-bar-wrapper'}>
                            <div className={'graph-bar'}>
                                {_.get(yearObj, 'rows[0].percentage') > 0 && (
                                    <Tooltip
                                        id={`${dataType}-first-bar-tooltip`}
                                        content={`${Number.parseFloat(_.get(yearObj, 'rows[0].percentage')).toFixed(
                                            2
                                        )}%`}
                                        position={POSITION.TOP}
                                        align={ALIGN.CENTER}
                                    >
                                        <div
                                            className={'bar bar-1'}
                                            style={{
                                                width: `${_.get(yearObj, 'rows[0].percentage')}%`,
                                                borderRightWidth:
                                                    _.get(yearObj, 'rows[0].percentage') < 100 ? '0px' : '1px',
                                            }}
                                        />
                                    </Tooltip>
                                )}
                                {_.get(yearObj, 'rows[1].percentage') > 0 && (
                                    <Tooltip
                                        id={`${dataType}-second-bar-tooltip`}
                                        content={`${Number.parseFloat(_.get(yearObj, 'rows[1].percentage')).toFixed(
                                            2
                                        )}%`}
                                        position={POSITION.TOP}
                                        align={ALIGN.CENTER}
                                    >
                                        <div
                                            className={'bar bar-2'}
                                            style={{
                                                width: `${_.get(yearObj, 'rows[1].percentage')}%`,
                                                // borderLeftWidth: (_.get(yearObj, 'rows[0].percentage') > 0) ? '0px' : '1px',
                                                // borderRightWidth: (_.get(yearObj, 'rows[2].percentage') > 0) ? '0px' : '1px',
                                            }}
                                        />
                                    </Tooltip>
                                )}
                                {_.get(yearObj, 'rows[2].percentage') > 0 && (
                                    <Tooltip
                                        id={`${dataType}-third-bar-tooltip`}
                                        content={`${Number.parseFloat(_.get(yearObj, 'rows[2].percentage')).toFixed(
                                            2
                                        )}%`}
                                        position={POSITION.TOP}
                                        align={ALIGN.CENTER}
                                    >
                                        <div
                                            className={'bar bar-3'}
                                            style={{
                                                width: `${_.get(yearObj, 'rows[2].percentage')}%`,
                                                borderLeftWidth:
                                                    _.get(yearObj, 'rows[2].percentage') < 100 ? '0px' : '1px',
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                            <div className={'graph-scale'}>
                                <span className={'scale-value value-1'}>{'0 %'}</span>
                                <span className={'scale-value value-2'}>{'25 %'}</span>
                                <span className={'scale-value value-3'}>{'50 %'}</span>
                                <span className={'scale-value value-4'}>{'75 %'}</span>
                                <span className={'scale-value value-5'}>{'100 %'}</span>
                            </div>
                        </div>
                    )}
                </div>
                {showDataTable && (
                    <div className={'table-container'}>
                        <div className={'table-title-wrapper'}>
                            <span className={'table-title'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                            </span>
                            <button
                                className={'remove-data-table'}
                                onClick={() => this.onToggleDataTableActive(false)}
                            />
                        </div>
                        <div className={'table-wrapper'}>
                            <DataTable data={_.get(yearObj, 'rows', [])} />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
